export default {

    setPopupFlag(state, module) {
        if (state[module] !== undefined) {
            state[module] = true;
        }
    },

}